var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveclass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.501,
    height: 34.072,
    viewBox: "0 0 24.501 34.072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "liveclass",
    transform: "translate(-751.506 -292.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(751.506 303.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M21.027,7.9a28.473,28.473,0,0,0-5.819-.508c-1.647,0-3.3.087-4.8.207l4.032-4.2a.383.383,0,0,0-.553-.53l-4.6,4.786a.392.392,0,0,0-.037.048c-.3.029-.583.057-.858.086a.38.38,0,0,0-.082-.134l-4.6-4.786a.383.383,0,1,0-.553.53L7.478,7.883c-1.725.2-2.848.392-2.848.392C-.072,9.064,0,11.713,0,11.713c-.079,2.057.772,9.537.772,9.537a5.908,5.908,0,0,0,5.02,4.2,47.1,47.1,0,0,0,6.536.316c3.363,0,6.575-.127,6.575-.127a4.215,4.215,0,0,0,3.858-2.673C24.5,19.529,24.5,11.2,24.5,11.2,24.5,8.633,21.027,7.9,21.027,7.9ZM18.6,21.012a4.134,4.134,0,0,1-3.8,2.981s-3.818.238-6.083.238a11.913,11.913,0,0,1-1.328-.052h-.1A4.726,4.726,0,0,1,2.694,21.01a43.868,43.868,0,0,1-.969-7.4,3.884,3.884,0,0,1,.158-1.141,4.013,4.013,0,0,1,3.155-2.453A25.781,25.781,0,0,1,11.382,9.3a29.93,29.93,0,0,1,3.069.157c2.646.275,4.718,1.48,4.685,4.341a42.8,42.8,0,0,1-.535,7.212Zm2.164-1.31a.8.8,0,1,1,.564-.233.8.8,0,0,1-.564.233Zm.38-2.68a.8.8,0,1,1,.564-.233A.8.8,0,0,1,21.146,17.021Zm.67-2.807H20.667a.38.38,0,0,1,0-.76h1.148a.38.38,0,1,1,0,.76Z",
    transform: "translate(0.004 -2.748)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(774.805 293.405) rotate(92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M5,21.743a.8.8,0,0,0,.618-.265.854.854,0,0,0,0-1.238,13.179,13.179,0,0,1,0-18.745A.876.876,0,1,0,4.375.256a15.054,15.054,0,0,0,0,21.222.956.956,0,0,0,.618.265Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M4.089.266a.854.854,0,0,0-1.238,0,9.769,9.769,0,0,0,0,13.794.876.876,0,1,0,1.238-1.238,7.953,7.953,0,0,1,0-11.232.962.962,0,0,0,0-1.324Z",
    transform: "translate(5.328 3.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(759.253 313.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M35.784,983.361a.811.811,0,0,0-.784.819v5.173a.808.808,0,0,0,1.205.717l4.484-2.594a.814.814,0,0,0,0-1.412l-4.484-2.594a.838.838,0,0,0-.421-.109Z",
    transform: "translate(-35 -983.361)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveclass);
export default __webpack_public_path__ + "static/media/liveclass.46cda3f1a1e03f4dc219914cb6f09074.svg";
export { ForwardRef as ReactComponent };